import formatAssignmentOption from '$utils/formatAssignmentOption';
import adaptLegacyGradeType from './adaptLegacyGradeType';
import isArrayEmpty from './isArrayEmpty';

const filterAssignmentOptions = ({
  selectedAssignments,
  selectedGradeType,
  assignments,
  isOnlySelector,
}) => {
  if (isArrayEmpty(assignments)) {
    return [];
  }

  // no assignment has been selected
  if (isArrayEmpty(selectedAssignments)) {
    return assignments.map(formatAssignmentOption);
  }

  const selectedAssignmentIds = selectedAssignments.map(({ id }) => id);

  // if there's only one assignment selector
  // educator still be able to select other gradeTypes
  if (isOnlySelector) {
    return (
      assignments
        .map(({ title, id, gradeType }) =>
          formatAssignmentOption({
            title,
            id,
            gradeType,
            isDisabled: selectedAssignmentIds.includes(id),
          })
        )
        // sort non disabled options first
        .sort(({ isDisabled }) => (isDisabled ? 1 : -1))
    );
  }

  // more than one assignment selectors
  // educator can't select other gradeTypes
  return (
    assignments
      .map(({ gradeType, title, id }) =>
        formatAssignmentOption({
          title,
          id,
          gradeType,
          isDisabled:
            selectedGradeType !== adaptLegacyGradeType(gradeType) ||
            selectedAssignmentIds.includes(id),
        })
      )
      // sort non disabled options first
      .sort(({ isDisabled }) => (isDisabled ? 1 : -1))
  );
};

export default filterAssignmentOptions;
